import { getDictionary } from "src/decidim/i18n";
document.addEventListener("DOMContentLoaded", function() {
  const gusButtons = document.querySelectorAll(".get-gus-data-button");
  const logoInput = document.getElementById("user_institution_logo");
  const logoPreview = document.getElementById("logo-preview");
  const logoImage = logoPreview.querySelector("img");
  const gusI18n = getDictionary("gus");
  logoInput.addEventListener("change", handleLogoInputChange);
  gusButtons.forEach(function(gusButton) {
    const formContainer = gusButton.closest(".organization-type");
    const regonField = formContainer.querySelector('input[name="user[institution][regon]"]');
    if (gusButton && regonField) {
      gusButton.addEventListener("click", function(e) {
        e.preventDefault();
        const regon = regonField.value.trim();
        if (!regon) {
          updateAriaLive(gusI18n.regonRequired, gusButton, formContainer, "assertive");
          showError(gusI18n.regonRequired, gusButton);
          return;
        }
        fetchGusData(regon, gusButton, formContainer);
      });
    }
  });
  function fetchGusData(regon, gusButton, formContainer) {
    gusButton.disabled = true;
    const originalText = gusButton.innerHTML;
    gusButton.innerHTML = gusI18n.loading;
    updateAriaLive(gusI18n.loading, gusButton, formContainer);
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
    fetch("/registration/gus_data/fetch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ regon })
    }).then((response) => {
      if (response.status === 429) {
        return response.json().then((data) => {
          const rateLimitMsg = gusButton.dataset.rateLimitMsg || data.error;
          throw new Error(rateLimitMsg);
        });
      }
      return response.json();
    }).then((data) => {
      if (data.success) {
        populateForm(data.data, formContainer);
        showSuccess(gusI18n.dataLoaded, gusButton);
      } else {
        showError(data.error || gusI18n.apiError, gusButton);
      }
    }).catch((error) => {
      console.error("Error:", error);
      showError(error.message || gusI18n.apiError, gusButton);
    }).finally(() => {
      gusButton.disabled = false;
      gusButton.innerHTML = originalText;
    });
  }
  function populateForm(data, formContainer) {
    const fieldMapping = {
      "name": data.name,
      "nip": data.nip,
      "krs": data.krs,
      "regon": data.regon,
      // This now contains the original REGON (not 14-digit version)
      "legal_form": data.legal_form,
      "street_name": data.street_name,
      "building_no": data.building_no,
      "apartment_no": data.apartment_no,
      "postal_code": data.postal_code,
      "city": data.city
    };
    Object.entries(fieldMapping).forEach(([fieldName, value]) => {
      const fields = formContainer.querySelectorAll(`
          input[name="user[institution][${fieldName}]"],
          input[name="user[institution][${fieldName}_readonly]"],
          textarea[name="user[institution][${fieldName}]"],
          textarea[name="user[institution][${fieldName}_readonly]"]`);
      fields.forEach((field) => field.value = value);
    });
  }
  function showError(message, gusButton) {
    const formContainer = gusButton.closest(".organization-type");
    updateAriaLive(message, gusButton, formContainer, "assertive");
    showNotification(message, "error", gusButton);
  }
  function showSuccess(message, gusButton) {
    const formContainer = gusButton.closest(".organization-type");
    updateAriaLive(message, gusButton, formContainer, "polite");
    showNotification(message, "success", gusButton);
  }
  function updateAriaLive(message, gusButton, formContainer, politeness = "polite") {
    const ariaLiveRegion = formContainer.querySelector("[aria-live]");
    if (ariaLiveRegion) {
      if (politeness === "assertive") {
        ariaLiveRegion.setAttribute("aria-live", "assertive");
      } else {
        ariaLiveRegion.setAttribute("aria-live", "polite");
      }
      ariaLiveRegion.textContent = "";
      setTimeout(() => {
        ariaLiveRegion.textContent = message;
      }, 100);
    }
  }
  function showNotification(message, type, gusButton) {
    const formContainer = gusButton.closest(".organization-type");
    const existingNotifications = formContainer.querySelectorAll(".gus-notification");
    existingNotifications.forEach((notification2) => notification2.remove());
    const notification = document.createElement("div");
    notification.className = `gus-notification alert alert-${type === "error" ? "danger" : "success"} mt-2`;
    notification.style.cssText = `
      padding: 12px 16px;
      margin-top: 8px;
      border-radius: 4px;
      font-size: 14px;
      ${type === "error" ? "background-color: #fee; border: 1px solid #fcc; color: #c33;" : "background-color: #efe; border: 1px solid #cfc; color: #363;"}
    `;
    notification.textContent = message;
    gusButton.parentNode.insertBefore(notification, gusButton.nextSibling);
    if (type === "success") {
      setTimeout(() => {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 5e3);
    }
  }
  const gusFields = ["name", "nip", "krs", "regon", "legal_form", "street_name", "building_no", "apartment_no", "postal_code", "city"];
  for (const field of gusFields) {
    const targetElement = document.querySelector(`[name="user[institution][${field}_readonly]`);
    const sourceElement = document.querySelector(`[name="user[institution][${field}]`);
    if (targetElement && sourceElement) {
      targetElement.value = sourceElement.value;
    }
  }
  function handleLogoInputChange() {
    const file = logoInput.files.item(0);
    if (!file) {
      logoImage.src = "";
      return;
    }
    if (file.type.match(/^image\/.*/)) {
      logoImage.src = URL.createObjectURL(file);
    }
  }
});
